<template>
  <div class="master-container">
    <v-content>
      <v-card flat class="mx-3 mt-2 pa-2" :loading="loading">
        <v-card-title>保守点検新規登録</v-card-title>
        <v-list-item-subtitle><strong class="red--text text--lighten-1">*</strong>：必須項目</v-list-item-subtitle>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-select
            readonly
            disabled
            v-model="formData.kiyk_cd"
            :items="kiykList"
            :rules="mainRules"
            label="契約先名*"
            item-value="kiyk_cd"
            item-text="kiyk_nm"
            required
          >
            <template v-slot:label>
              契約先名<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-select>
          <v-select
            v-model="formData.kki_cd"
            :rules="mainRules"
            :items="kkiList"
            @change="selectkki($event)"
            label="機械名*"
            item-value="kki_cd"
            item-text="kki_nm"
            required
            return-object
          >
            <template v-slot:label>
              機械名<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-select>
          <v-select
            v-model="formData.bhn_id"
            :items="bhnList"
            :rules="mainRules"
            @change="selectbhn($event)"
            label="部品名*"
            item-value="bhn_id"
            item-text="name_label"
            required
            return-object
          >
            <template v-slot:label>
              部品名<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-select>
          <v-text-field
            v-model="formData.bhn_num"
            :rules="this.bhnNumRules()"
            label="個数"
            required
          >
            <template v-slot:label>
              個数<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-text-field>
          <v-select
            :rules="mainRules"
            v-model="formData.sum_typ"
            :items="sumTypeList"
            @change="selectsum($event)"
            label="集計方法"
            item-value="no"
            item-text="name"
            required
            return-object
          >
            <template v-slot:label>
              集計方法<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-select>
          <v-text-field
            v-model="formData.kukn_kikk_val"
            :rules="numberRules"
            label="交換警告値"
            required
          >
            <template v-slot:label>
              交換警告値<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-text-field>
          <v-text-field
            v-model="formData.kukn_sish_val"
            :rules="numberRules"
            label="交換推奨値"
            required
          >
            <template v-slot:label>
              交換推奨値<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-text-field>
          <v-container mx-0>
            <v-row>
              <v-col class="cols-6 px-0 pr-2">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="formData.kukn_dt"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="formData.kukn_dt"
                  :rules="mainRules"
                  label="交換日付"
                  readonly
                  append-icon="event"
                  v-on="on"
                  required
                >
                  <template v-slot:label>
                    交換日付<strong class="red--text text--lighten-1">*</strong>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker v-model="formData.kukn_dt" no-title scrollable>
                <v-spacer />
                <v-btn text color="primary" @click="menu = false">キャンセル</v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(formData.kukn_dt)">選択</v-btn>
              </v-date-picker>
            </v-menu>
              </v-col><v-col class="cols-6 px-0 pl-2">
            <v-text-field
              v-model="formData.kukn_tm"
              value="00:00"
              label="交換時間"
              type="time"
            >
            </v-text-field>
            </v-col>
            </v-row>
          </v-container>
          <v-btn width="120" color="indigo lighten-5" depressed to='/HshTnknMstr/HshTnknMstrKnr'>キャンセル</v-btn>
          <div class="float-right">
            <!-- 保存された情報をダイアログに表示 -->
            <v-dialog v-model="checkDialog" width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark color="indigo" width="120" v-bind="attrs" v-on="on" @click="validate">
                  登録
                </v-btn>
              </template>
              <v-card v-if="errorFlg">
                <v-card-title class="headline indigo lighten-4" primary-title>新規登録確認</v-card-title>
                <v-card-text>
                  <v-container>
                    <span style="white-space:pre-wrap;">{{errorMsg}}</span>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="indigo" text @click="checkDialog = false">OK</v-btn>
                </v-card-actions>
              </v-card>
              <v-card v-else>
                <v-card-title class="headline indigo lighten-4" primary-title>新規登録確認</v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      以下の内容で登録します。よろしいですか？<br>
                    </v-row>
                    <v-row>
                      <div v-if="validerrorFlg">
                        <span class="text-left red--text text--lighten-1">
                          {{MSG_E002_0008}}
                        </span>
                      </div>
                    </v-row>
                    <!-- 登録内容 -->
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">契約先名</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{kiykSelectList.kiyk_nm}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">機械名</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{kkiSelectList.kki_nm}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">部品名</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{bhnSelectList.bhn_nm}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">個数</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{formData.bhn_num}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">集計方法</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{sumSelectList.name}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">交換警告値</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{formData.kukn_kikk_val}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">交換推奨値</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{formData.kukn_sish_val}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">交換日付</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{formData.kukn_dt}} {{formData.kukn_tm}}
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-container v-if="bhninfoFlg">
                    <v-row>
                      新しく登録する部品の情報を入力してください。<br>
                    </v-row>
                    <br>
                    <v-row>
                      <template v-slot:label>
                        部品ｺｰﾄﾞ<strong class="red--text text--lighten-1">*</strong>
                      </template>
                      <v-text-field
                        v-model="formData.bhn_cd_snk"
                        label="部品ｺｰﾄﾞ"
                        :rules="cdRules"
                        required
                      >
                        <template v-slot:label>
                          部品ｺｰﾄﾞ<strong class="red--text text--lighten-1">*</strong>
                        </template>
                      </v-text-field>
                    </v-row>
                    <v-row>
                      <template v-slot:label>
                        部品名<strong class="red--text text--lighten-1">*</strong>
                      </template>
                      <v-text-field
                        v-model="formData.bhn_nm_snk"
                        label="部品名"
                        :rules="Rules50"
                        required
                      >
                        <template v-slot:label>
                          部品名<strong class="red--text text--lighten-1">*</strong>
                        </template>
                      </v-text-field>
                    </v-row>
                    <v-row>
                      <template v-slot:label>
                        個数<strong class="red--text text--lighten-1">*</strong>
                      </template>
                      <v-text-field
                        readonly
                        disabled
                        v-model="formData.bhn_num_snk"
                        label="個数"
                      >
                      </v-text-field>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="indigo" text @click="checkDialog = false">キャンセル</v-btn>
                  <v-btn dark color="indigo" width="120" @click="submit()">登録</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-form>
      </v-card>
    </v-content>
  </div>
</template>

<script>
import MstrHedr from '../../modules/MstrHedr'
import MsgList from '../../modules/MsgList'
import myAxios from '../../../axios/myAxios'

export default {
  components: {
    MstrHedr
  },
  props: {
    formData: Object
  },
  data () {
    return {
      mainRules: [
        v => !!v || '入力は必須です'
      ],
      Rules100: [
        v => (v || '').search(' ') !== 0 || '最初に空欄を入れることは禁止です',
        v => (v || '').search('　') !== 0 || '最初に空欄を入れることは禁止です',
        v => (v == null || v === '' || v.length <= 100) || '100文字以内で入力してください'
      ],
      numberRules: [
        v => !!v || '入力は必須です',
        v => (/^[0-9.]+$/.test(v) || v === '') || '半角数字で入力してください',
        v => (v === '' || (v || '').match(/^([1-9][0-9]*|0)(\.[0-9]{1,3})?$/)) || '小数点3桁以下で入力してください',
        v => (v === '' || v.length <= 15) || '半角数字15文字以内で入力してください'
      ],
      Rules50: [
        v => !!v || '入力は必須です',
        v => (v || '').search(' ') !== 0 || '最初に空欄を入れることは禁止です',
        v => (v || '').search('　') !== 0 || '最初に空欄を入れることは禁止です',
        v => (v == null || v.length <= 50) || '50文字以内で入力してください'
      ],
      cdRules: [
        v => !!v || '入力は必須です',
        v => (v || '').match(/^[A-Za-z0-9!@$\-#_.]*$/) || '半角英数字および!@#$-_.で入力してください',
        v => (v || '').indexOf(' ') < 0 || '空文字が含まれています',
        v => (v || '').indexOf('　') < 0 || '空文字が含まれています',
        v => (v.length <= 50) || '50文字以内で入力してください'
      ],
      loading: true,
      checkDialog: false,
      menu: false,
      userInfo: false,
      kkiCdIsValid: true,
      bhnIDIsValid: true,
      bhnNumIsValid: true,
      kiykCdIsValid: true,
      numberKIsValid: true,
      numberSIsValid: true,
      kuknIsValid: true,
      sumIsValid: true,
      blankIsValid: true,
      bhnCdIsValid: true,
      bhnNameIsValid: true,
      valid: true,
      isChange: false,
      kiykList: [],
      kiykListLen: 0,
      kiykSelectList: {},
      bhnList: [],
      bhnSelectList: { bhn_id: '', bhn_nm: '', bhn_cd: '' },
      kkiList: [],
      kkiSelectList: { kki_cd: '', kki_nm: '' },
      sumTypeList: [],
      sumSelectList: { name: '', no: '' },
      errorFlg: false,
      errorMissMsg: '入力内容に間違いがあります。',
      errorNumMsg: '小数点3桁以下は省略されます。',
      errorMsg: '',
      user: {
        kngn_typ: null,
        kiyk_cd: null
      },
      defaultBhnNum: 0,
      kosu: '',
      msg: '',
      bhninfoFlg: false,
      validerrorFlg: false,
      MSG_E002_0008: MsgList.MSG_E002_0008,
      select_kki_cd: '',
      select_bhn_id: '',
      select_sum_typ: ''
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isChange) {
      const dialog = window.confirm(MsgList.MSG_CREATE_FORM_LEAVE)
      if (dialog) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  created () {
    // ログインセッションを確認する
    myAxios.get('/api/common/session_manager', {type: 'isLogin'}).then(res => {
      const status = res.data.status
      const result = res.data.result
      myAxios.get('/api/common/session_manager', {type: 'kngn_check', url: this.$route.path}).then(res => {
        const kngnStatus = res.data.result.status
        // ログインセッションを確認できなければログイン画面に遷移する
        if (!(status && result && kngnStatus)) {
          alert(MsgList.MSG_SES_CANNOT_CONFIRM)
          this.$router.push('/')
          this.$store.dispatch('appSetting/fLogin')
        } else {
          this.$store.dispatch('appSetting/tLogin')
          // 入力フォームに表示するセレクトボックスの選択肢を取得
          myAxios.get('api/hshtnkn_mstr/hshtnkn_master_shinki_touroku').then(res => {
            this.kiykList = res.data.keiyaku_list
            this.kiykListLen = this.kiykList.length
            this.bhnList = res.data.buhin_list
            this.kkiList = res.data.kikai_list
            this.sumTypeList = res.data.sum_list
            // 空欄を削除
            for (var i = 0; i < this.sumTypeList.length; i++) {
              this.sumTypeList[i].no = this.sumTypeList[i].no.trim()
            }
          })
          // ログインユーザの権限区分と契約コードを取得する
          myAxios.get('api/common/session_manager', {type: 'userinfo_kngn_kiyk'}).then(res => {
            this.user.kngn_typ = res.data.kngn_typ.trim()
            this.user.kiyk_cd = res.data.kiyk_cd
            this.formData.kiyk_cd = res.data.kiyk_cd
            this.loading = false
          })
        }
      })
    })
  },
  methods: {
    insertKiyk () {
      // 契約先の名前を取得する
      var i = 0
      while (i < this.kiykListLen) {
        if (this.kiykList[i].kiyk_cd === this.user.kiyk_cd) {
          this.kiykSelectList = this.kiykList[i]
        }
        i++
      }
    },
    validate () {
      this.insertKiyk()
      this.checkForm()
    },
    // 契約先入力チェック
    checkKiyk () {
      if (!this.formData.kiyk_cd) {
        this.kiykCdIsValid = false
        this.blankIsValid = false
      } else {
        this.kiykCdIsValid = true
      }
    },
    // 機械入力チェック
    checkKki () {
      if (!this.formData.kki_cd) {
        this.kkiCdIsValid = false
        this.blankIsValid = false
      } else {
        this.kkiCdIsValid = true
      }
    },
    // 部品入力チェック
    checkBhn () {
      if (!this.formData.bhn_id) {
        this.bhnIDIsValid = false
        this.blankIsValid = false
      } else {
        this.bhnIDIsValid = true
      }
    },
    // 集計方法入力チェック
    checkSum () {
      if (!this.formData.sum_typ) {
        this.sumIsValid = false
        this.blankIsValid = false
      } else {
        this.sumIsValid = true
      }
    },
    // 交換履歴入力チェック
    checkKukn () {
      if (!this.formData.kukn_dt) {
        this.kuknIsValid = false
        this.blankIsValid = false
      } else {
        this.kuknIsValid = true
      }
    },
    checkNumber () {
      // 警告
      if (this.formData.kukn_kikk_val == null || this.formData.kukn_kikk_val === '') {
        this.formData.kukn_kikk_val = null
        this.numberKIsValid = false
        this.blankIsValid = false
      // 数字のみかチェック
      } else if (!this.formData.kukn_kikk_val.match(/^([1-9][0-9]*|0)(\.[0-9]{1,3})?$/)) {
        this.numberKIsValid = false
      // 空欄チェック
      } else if ((this.formData.kukn_kikk_val).indexOf(' ') > 0) {
        this.numberKIsValid = false
      // 15文字以内かチェック
      } else if (this.formData.kukn_kikk_val.length > 15) {
        this.numberKIsValid = false
      } else {
        this.numberKIsValid = true
        // this.formData.kukn_kikk_val = Math.round(this.formData.kukn_kikk_val * 1000) / 1000
      }

      // 推奨
      if (this.formData.kukn_sish_val == null || this.formData.kukn_sish_val === '') {
        this.formData.kukn_sish_val = null
        this.numberSIsValid = false
        this.blankIsValid = false
      // 数字のみかチェック
      } else if (!this.formData.kukn_sish_val.match(/^([1-9][0-9]*|0)(\.[0-9]{1,3})?$/)) {
        this.numberSIsValid = false
        // 空欄チェック
      } else if ((this.formData.kukn_sish_val).indexOf(' ') > 0) {
        this.numberSIsValid = false
      // 15文字以内かチェック
      } else if (this.formData.kukn_sish_val.length > 15) {
        this.numberSIsValid = false
      } else {
        this.numberSIsValid = true
      }
    },
    // ポップアップで部品情報入力チェック
    checkBhnInfo () {
      // 部品ｺｰﾄﾞ
      // ブランクチェック
      if (!this.formData.bhn_cd_snk) {
        this.bhnCdIsValid = false
      // 空文字チェック
      } else if (this.formData.bhn_cd_snk.indexOf(' ') > 0) {
        this.bhnCdIsValid = false
      } else if (this.formData.bhn_cd_snk.indexOf('　') > 0) {
        this.bhnCdIsValid = false
      // 文字数50チェック
      } else if (this.formData.bhn_cd_snk.length > 50) {
        this.bhnCdIsValid = false
      // 記号を含むかチェック
      } else if (!(this.formData.bhn_cd_snk).match(/^[A-Za-z0-9!@$#_\-.]*$/)) {
        this.bhnCdIsValid = false
      // 全て範囲内ならtrue
      } else {
        this.bhnCdIsValid = true
        this.errorCdMsg = ''
      }

      // 部品名
      // ブランクチェック
      if (!this.formData.bhn_nm_snk) {
        this.bhnNameIsValid = false
      // 空文字チェック
      } else if (this.formData.bhn_nm_snk.search('　') === 0) {
        this.bhnNameIsValid = false
      } else if (this.formData.bhn_nm_snk.search(' ') === 0) {
        this.bhnNameIsValid = false
      // 文字数50チェック
      } else if (this.formData.bhn_nm_snk.length > 50) {
        this.bhnNameIsValid = false
      // 全て範囲内ならtrue
      } else {
        this.bhnNameIsValid = true
      }
    },
    // エラーメッセージを作成する
    makeErrorMsg () {
      this.errorMsg = ''
      // blankエラー
      if (!this.blankIsValid) {
        this.errorMsg = MsgList.MSG_FORM_INVALID + '\n'
      }
      // 入力間違いエラー
      this.errorMsg = this.errorMsg + this.errorMissMsg + '\n'
      this.blankIsValid = true
    },
    // 確認画面遷移前チェックを行う
    checkForm () {
      // 上部エラーメッセージをオフ
      this.validerrorFlg = false
      // 部品情報登録フォームをオフ
      this.bhninfoFlg = false
      // formDataに格納
      // this.kkiSelectList = this.formData.kki_cd
      // this.bhnSelectList = this.formData.bhn_id
      // this.sumSelectList = this.formData.sum_typ
      // 何も入力されていなければ空欄にする
      // if (this.formData.kki_cd === null) {
      //   this.kkiSelectList = { kki_cd: '', kki_nm: '' }
      // }
      // if (this.formData.bhn_id === null) {
      //   this.bhnSelectList = { bhn_id: '', bhn_nm: '', bhn_cd: '' }
      // }
      // if (this.formData.sum_typ === null) {
      //   this.sumSelectList = { name: '', no: '' }
      // }
      // 機械コード
      let k = this.kkiList.findIndex(v => v.kki_cd === this.select_kki_cd)
      // indexが不正の場合は初期値
      if (k === -1) {
        this.kkiSelectList = { kki_cd: '', kki_nm: '' }
      } else {
        this.kkiSelectList = this.kkiList[k]
      }
      // 部品名
      let b = this.bhnList.findIndex(v => v.bhn_id === this.select_bhn_id)
      // indexが不正の場合は初期値
      if (b === -1) {
        this.bhnSelectList = { bhn_cd: '', bhn_nm: '' }
      } else {
        this.bhnSelectList = this.bhnList[b]
      }
      // 集計方法
      let s = this.sumTypeList.findIndex(v => v.no === this.select_sum_typ)
      // indexが不正の場合は初期値
      if (s === -1) {
        this.sumSelectList = { name: '', no: '' }
      } else {
        this.sumSelectList = this.sumTypeList[s]
      }
      // 各フォームを再チェック
      this.checkKiyk()
      this.checkKki()
      this.checkBhn()
      this.checkSum()
      this.checkKukn()
      this.checkNumber()
      this.$refs.form.validate()
      // 個数に差分があるか
      var kosusbn = this.defaultBhnNum - this.formData.bhn_num
      if (parseInt(kosusbn) > 0) {
        this.bhninfoFlg = true
        // ポップアップで入力する内容の初期値を設定
        this.formData.bhn_cd_snk = this.bhnSelectList.bhn_cd
        this.formData.bhn_nm_snk = this.bhnSelectList.bhn_nm + '_差分'
        this.formData.bhn_num_snk = kosusbn
      }
      // チェック項目が全て true ならば確認画面を表示する false があればアラートを表示する
      if (this.kuknIsValid && this.kiykCdIsValid && this.kkiCdIsValid && this.bhnIDIsValid && this.numberSIsValid && this.numberKIsValid && this.sumIsValid && this.bhnNumIsValid) {
        this.isChange = false
        this.errorFlg = false
      } else {
        this.errorFlg = true
        this.makeErrorMsg()
      }
    },
    // 入力データをサーバーに送信・登録処理を行う
    submit () {
      // 個数差分が発生した場合のみチェック
      if (this.bhninfoFlg) {
        this.checkBhnInfo()
        this.$refs.form.validate()
      }
      if (this.bhnCdIsValid && this.bhnNameIsValid) {
        this.validerrorFlg = false
        this.checkDialog = false
        // kki_cd,bhn_idに入っているobjectをkki_cd,bhn_idだけにする
        this.formData.kki_cd = this.formData.kki_cd.kki_cd
        this.formData.bhn_id = this.formData.bhn_id.bhn_id
        this.formData.sum_typ = this.formData.sum_typ.no

        // 数値を空の場合はnullにする
        if (this.formData.kukn_kikk_val == null || this.formData.kukn_kikk_val === '') {
          this.formData.kukn_kikk_val = null
        }
        if (this.formData.kukn_sish_val == null || this.formData.kukn_sish_val === '') {
          this.formData.kukn_sish_val = null
        }

        myAxios.post('/api/hshtnkn_mstr/hshtnkn_master_shinki_touroku_kakunin', this.formData).then(res => {
          const status = res.data.status
          const result = res.data.result

          if (status && result) {
            this.$router.push('/HshTnknMstr/HshTnknMstrKnr')
          } else {
            alert(MsgList.MSG_FORM_SUBMIT_ERROR)
          }
        // eslint-disable-next-line handle-callback-err
        }).catch(err => {
          alert(MsgList.MSG_FORM_SUBMIT_ERROR)
        })

        // 選択中の値を再設定する
        this.formData.kki_cd = this.select_kki_cd
        this.formData.bhn_id = this.select_bhn_id
        this.formData.sum_typ = this.select_sum_typ
      } else {
        // ダイアログ上部にエラーメッセージ表示
        this.validerrorFlg = true
      }
    },
    // 機械名が選択されたら個数を表示
    selectkki (event) {
      this.select_kki_cd = event.kki_cd
    },
    // 部品名が選択されたら個数を表示
    selectbhn (event) {
      // 初期値は内部で保持する
      this.defaultBhnNum = event.bhn_num
      // 部品個数に個数を表示
      this.formData.bhn_num = event.bhn_num
      this.kosu = event.bhn_num
      this.select_bhn_id = event.bhn_id
    },
    // 集計方法が選択されたら個数を表示
    selectsum (event) {
      this.select_sum_typ = event.no
    },
    bhnNumRules () {
      var res = []
      var v = this.formData.bhn_num
      this.bhnNumIsValid = true

      // 入力チェック
      if (this.formData.bhn_id === null) {
        res.push('部品名を先に選択してください')
        this.bhnNumIsValid = false
      } else if (!v) {
        res.push('入力は必須です')
        this.bhnNumIsValid = false
      } else if (!(/^[0-9]+$/.test(v))) {
        res.push('半角数字で入力してください')
        this.bhnNumIsValid = false
      } else if (v.length > 5) {
        res.push('半角数字5文字以内で入力してください')
        this.bhnNumIsValid = false
      } else if (v === '0' || parseInt(v) > this.defaultBhnNum) {
        res.push('1～部品に登録された個数間の数値を入力してください')
        this.bhnNumIsValid = false
      }
      return res
    }
  },
  computed: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/HshTnknMstr/HshTnknMstrSnkTurk.vue